import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { BackendModule } from 'app/shared/backend';
import { TASK_INTERCEPTORS, TaskInterceptor, TasksResult } from 'app/shared/backend/tasks.service';
import { catchError, defer, EMPTY, finalize, forkJoin, Observable, tap } from 'rxjs';
import { LoadingBarComponent } from './loading-bar.component';
import { LoadingBarService } from './loading-bar.service';


@Injectable()
export class LoadingBarInterceptor implements HttpInterceptor {

    constructor(private loadingBarService: LoadingBarService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        if (req.headers.has('ignoreLoadingBar')) {
            return next.handle(req.clone({ headers: req.headers.delete('ignoreLoadingBar') }));
        }

        return defer(() => {
            this.loadingBarService.comp?.start();
            return next.handle(req).pipe(finalize(() => {
                this.loadingBarService.comp?.complete();
            }));
        });
    }
}


@Injectable()
export class LoadingBarTasksService<T> implements TaskInterceptor<T> {

    constructor(private loadingBarService: LoadingBarService) {}

    intercept(result: Observable<TasksResult<T>>) {
        return defer(() => {
            this.loadingBarService.comp?.start();
            return result.pipe(tap(({ tasks }) => {
                forkJoin(tasks.map(t => t.result.pipe(catchError(() => EMPTY)))).pipe(finalize(() => {
                    this.loadingBarService.comp?.complete();
                })).subscribe();
            }));
        });
    }
}


@NgModule({
    imports: [
        HttpClientModule,
        BackendModule,
        LoadingBarComponent,
    ],
    exports: [
        LoadingBarComponent,
    ],
})
export class LoadingBarModule {

    static forRoot(): ModuleWithProviders<LoadingBarModule> {
        return {
            ngModule: LoadingBarModule,
            providers: [
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: LoadingBarInterceptor,
                    multi: true,
                },
                {
                    provide: TASK_INTERCEPTORS,
                    useClass: LoadingBarTasksService,
                    multi: true,
                },
            ],
        };
    }
}
